export const DOCUMENT_UPLOAD_REQUEST_TOKEN_PARAM = 'ticket'

export function documentUploadRequestQuery(token: string): string {
  return `?${DOCUMENT_UPLOAD_REQUEST_TOKEN_PARAM}=${encodeURIComponent(token)}`
}
